import {Injectable} from '@angular/core';
import {ToolsService} from '../../tools/tools.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GameSectionService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  findAll() {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}sections`).toPromise();
  }

}
